/**
 * V1.0.48: Helper xưng hô đúng giới tính trong UI, notification, lời chào.
 *
 * Gender value gốc từ backend qua field user.gender (UNKNOWN/MALE/FEMALE).
 *
 * V1.0.50 (chính sách mới): Toàn bộ xưng hô dùng "bạn" trung tính, không phân biệt giới tính.
 * Lý do: tránh sai sót khi gender chưa được cập nhật chính xác, và để phong cách giao tiếp
 * đồng nhất, lịch sự, không bị gò bó vào anh/chị.
 * Vẫn giữ helper structure để dễ rollback nếu cần.
 */
import type { Gender } from '@/types';

/** Đại từ không viết hoa. V1.0.50: luôn trả "bạn". */
export function getPronoun(_gender?: Gender | string | null): string {
  return 'bạn';
}

/** Đại từ viết hoa đầu câu. V1.0.50: luôn trả "Bạn". */
export function getPronounCapitalized(_gender?: Gender | string | null): string {
  return 'Bạn';
}

/** Label tiếng Việt hiển thị UI: "Nam"/"Nữ"/"Chưa xác định". */
export function getGenderLabel(gender?: Gender | string | null): string {
  switch ((gender ?? '').toUpperCase()) {
    case 'MALE': return 'Nam';
    case 'FEMALE': return 'Nữ';
    default: return 'Chưa xác định';
  }
}

/** Màu badge: blue (Nam), magenta (Nữ), default (Chưa xác định). */
export function getGenderColor(gender?: Gender | string | null): string {
  switch ((gender ?? '').toUpperCase()) {
    case 'MALE': return 'blue';
    case 'FEMALE': return 'magenta';
    default: return 'default';
  }
}

/**
 * Tạo lời chào lịch sự kèm tên.
 * V1.0.50: luôn dạng "Bạn <fullName>".
 */
export function formatGreeting(fullName: string, _gender?: Gender | string | null): string {
  return `Bạn ${fullName}`;
}

/**
 * Options cho Ant Design Select / Radio Group.
 * Giữ nguyên — gender field vẫn lưu trong DB để dùng cho mục đích khác (báo cáo, thống kê).
 */
export const GENDER_OPTIONS: { value: Gender; label: string }[] = [
  { value: 'UNKNOWN', label: 'Chưa xác định' },
  { value: 'MALE', label: 'Nam' },
  { value: 'FEMALE', label: 'Nữ' },
];
